export const CLOUDINARY_CONFIG = {
  cloudName: 'dnpur5g0i', // Replace with your cloud name
  uploadPreset: 'barhop_uploads', // We'll create this next
};
